import { Fade } from '@mui/material';
import { Components, Theme } from '@mui/material/styles';
import scssVariables from '@styles/variables.module.scss';

export const MuiTooltip: Components<Theme>['MuiTooltip'] = {
  defaultProps: {
    placement: 'top',
    arrow: true,
    enterDelay: 300,
    slots: {
      transition: Fade,
    },
    slotProps: {
      transition: {
        timeout: 200,
        easing: 'ease-out',
      },
      popper: {
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -4],
            },
          },
        ],
      },
    },
  },
  styleOverrides: {
    tooltip: {
      backgroundColor: scssVariables.ColorOffWhiteLight,
      boxShadow: '0px 4px 30px rgba(0, 0, 0, 0.3)',
      padding: '8px 12px',
      font: scssVariables.FontLabel,
      margin: '12px',
      color: scssVariables.ColorDarkGray,
      borderRadius: scssVariables.BorderRadiusSmall,
    },
    arrow: {
      color: scssVariables.ColorOffWhiteLight,
    },
    popper: {
      '&[data-popper-placement*="top"] .MuiTooltip-arrow::before': {
        borderBottomRightRadius: '2px',
      },
      '&[data-popper-placement*="right"] .MuiTooltip-arrow::before': {
        borderBottomLeftRadius: '2px',
      },
      '&[data-popper-placement*="bottom"] .MuiTooltip-arrow::before': {
        borderTopLeftRadius: '2px',
      },
      '&[data-popper-placement*="left"] .MuiTooltip-arrow::before': {
        borderTopRightRadius: '2px',
      },
    },
  },
};
